import { GenericBackendResponse } from '../genericBackendResponse';

export interface SyncOwnProfileResponse {
	userId: string;
	expedientId?: string;
	expedientFound: boolean;
	/** Campos que estaban vacíos y se han rellenado desde el expediente. */
	filledFields: string[];
	/** Campos que ya tenían valor: NO se pisan. */
	skippedFields: string[];
}

/**
 * Copia a comparsa lo que el usuario dejó en su expediente de KYC.
 *
 * Rellena SOLO los campos vacíos (`updateProfileFromKycIfEmpty`), así que no
 * sirve para corregir un IBAN equivocado: sirve para que el que acaba de darlo
 * llegue a `users.bank_account`, que es de donde lee la plataforma.
 */
const syncOwnProfile = async (
	token: string
): Promise<GenericBackendResponse<SyncOwnProfileResponse>> => {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/kyc/sync-profile/me`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	});

	if (!response.ok) {
		throw new Error(`KYC profile sync failed: ${response.status}`);
	}

	return response.json();
};

export default syncOwnProfile;
